import React from 'react';
import Answer from '../../../components/answer/index.js';
import Score from '../../../components/score';
import Breadcrumbs from '../../../components/breadcrumbs';

const Step = (props) => {
    return (
        <div className="screen">
            <form className="actView fadeIn" onSubmit={props.formHandler}>
                <div className="question">
                    <h3 className="header3">05</h3>
                    <h5 className="header5">How would you rate your asthma control during the past 4 weeks?</h5>
                    <div className="columns">
                        <div className="column">
                            <Answer handler={props.answerHandler} id={props.name + "0"} set={props.name} value="1" state={props.state}>Not controlled at all</Answer>
                            <Answer handler={props.answerHandler} id={props.name + "1"} set={props.name} value="2" state={props.state}>Poorly controlled</Answer>
                            <Answer handler={props.answerHandler} id={props.name + "2"} set={props.name} value="3" state={props.state}>Somewhat controlled</Answer>
                        </div>
                        <div className="column">
                            <Answer handler={props.answerHandler} id={props.name + "3"} set={props.name} value="4" state={props.state}>Well controlled</Answer>
                            <Answer handler={props.answerHandler} id={props.name + "4"} set={props.name} value="5" state={props.state}>Completely controlled</Answer>
                        </div>
                    </div>
                    <footnote class="legal">Copyright 2002, by QualityMetric Incorporated. <br />Asthma Control Test is a trademark of QualityMetric Incorporated.</footnote>
                </div>
                <button className="prev" type="button" onClick={props.prevHandler}>Back</button>
                <button className="next submit" type="submit" disabled>Submit</button>
            </form>
            <Score Score={props.TempScore} Results={false} role={props.role} />
            <Breadcrumbs Step={props.step} Steps={props.steps - 1} />
        </div>
    );
}

export default Step;
